import { Button, IconComponentLine, styled } from '@lessonup/ui-components';
import { TFunction } from 'i18next';
import React from 'react';

interface UploadsTabProps {
  handleUploadFromModal: () => Promise<void>;
  t: TFunction;
}

export const UploadsTab: React.FC<UploadsTabProps> = ({ handleUploadFromModal, t }) => {
  return (
    <Wrapper>
      <Button
        buttonType="secondary"
        showStroke
        iconStart={<IconComponentLine />}
        buttonShape="rect"
        size="small"
        onClick={handleUploadFromModal}
      >
        {t('imagePicker.browseUploadsButton')}
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
